module.exports = __webpack_public_path__ + "804037562eabaa5dbefa4a435206d017.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Light/OpenSans-Light.eot
// module id = 973
// module chunks = 0